export default __webpack_public_path__ + "static/media/TERMINAL_ICON_02.85b85f6a.svg";